<template>
  <b-card
      align="left"
      no-body class="overflow-hidden"
      style="margin: 5px; padding: 10px;"
    >
    <h1 v-bind:class="classColorRelevance(data_item.attributes['relevance'])" align="left">{{data_item.attributes['title']}}</h1>
    <h2 v-bind:class="classColorRelevance(data_item.attributes['relevance'])" align="right">{{data_item.attributes['reference-to-type']}} {{humanize(data_item.attributes['relevance'])}}</h2>
    <b-link :href=computed_link>{{computed_link}}</b-link>
    <div v-html="markIt(data_item.attributes['summary'])"></div>
  </b-card>
</template>

<script>
import marked from 'marked';

export default {
  props: {
    data_item: {
      Type: Object
    },
    mappings: {
      Type: Array
    },
    included: {
      Type: Array
    }
  },
  computed: {
     computed_link() {
       return this.data_item.attributes['url-link']
     }
  },
  methods: {
    markIt(str) {
      return marked(str)
    },
    classColorRelevance(str) {
      let my_style = "bg-light text-dark"
      switch(str) {
        case 'background_information':
          my_style = "bg-secondary text-white"
          break;
        case 'suggested_guideline':
          my_style = "bg-warning text-white"
          break;
        case 'required_rule':
          my_style = "bg-danger text-white"
          break;
        case 'obtain':
          my_style = "bg-primary text-white"
          break;
        case 'provide':
          my_style = "bg-success text-white"
          break;
        default:
         // :options="['background_information', 'suggested_guideline', 'required_rule', 'obtain', 'provide']"
          // code block
      }
      return my_style
    },
    humanize(str) {
      return str
          .replace(/^[\s_]+|[\s_]+$/g, '')
          .replace(/[_\s]+/g, ' ')
          .replace(/^[a-z]/, function(m) { return m.toUpperCase(); })
    }
  }
}
</script>

<style>
  @import '~simplemde/dist/simplemde.min.css';
  h1 { font-size: 24px; }
</style>